<template lang="pug">
v-app
  div(style="width:100%;height:10px;background:#1E2933")
  v-card(style="background-image: linear-gradient(#1e415e 10%,#2b5b84 90%);border-radius:0px;")
    v-card-text.pa-0.pt-2.pb-2
      v-container(style="max-width:1300px")
        v-row
          v-col(cols="10" md="5" offset="1" offset-md="0")
            v-card.rounded-0.rounded-t-lg.rounded-lg
              v-card-text.pa-1(style="overflow:hidden;").pb-3
                img(src="/img/new-logo-minedu.png" width="380px").pl-2
          v-col(cols="10" md="5" offset="1" offset-md="2")
            v-card.rounded-0.rounded-t-lg.rounded-lg(color="transparent" flat)
              v-card-text.pa-0(style="overflow:hidden;")
                img(src="/img/ugpsep-text.png" width="380px" style="float:right;margin-top:-6px;").pr-2.pb-3
  v-main
    v-container(style="max-width:1300px")
      v-card(dark style="margin-top:-45px;z-index:50;background-image: linear-gradient(#3776ab 30%,#2d618c 95%);border-top: 1px solid #629ccd;border-bottom: 1px solid #48639b;").rounded-lg.elevation-5
        v-card-text.pa-2
          v-btn(large color="rgba(0,0,0,0.1)" light style="border-bottom: 1px solid rgba(0,0,0,0.1);").txtn.pl-3.pr-3.mr-2.elevation-0.white--text
            v-icon mdi-home
            | &nbsp;Inicio
          v-btn(text large).pl-3.pr-3.txtn RC-IVA
          v-btn(text large).pl-3.pr-3.txtn Reposición y reversión<br> de boletas
          v-btn(text large).pl-3.pr-3.txtn Suplencias
          v-btn(text large).pl-3.pr-3.txtn Subsidios
      router-view
  v-footer(dark :absolute="!fixed" height="100" app style="background-image: linear-gradient(#1e415e 10%,#2b5b84 90%);")
    v-spacer
    span(style="text-align:center") Ayuda - Central de contactos<br>Copyright ©2021
    v-spacer
</template>

<script>
export default {
  data () {
    return {
      fixed: false
    }
  }
}
</script>
